const D3Utility = {
  getDates: (selection) => {
    const currentDate = new Date();
    const currentTime = currentDate.getTime();
    let startTime;
    const day = 24 * 60 * 60 * 1000;
    if (selection === 0) {
      startTime = currentTime - day;
    } else if (selection === 1) {
      startTime = currentTime - (2 * day);
    } else if (selection === 2) {
      startTime = currentTime - (7 * day);
    }
    return { startTime, endTime: currentTime };
  },
  getDataInRange: (data, startTime) => {
    if (data.length === 0) {
      return data;
    }
    const toGraph = data.filter((reading) => reading.timestamp > startTime);
    return toGraph;
  },
  getTimeZoneDate: (timeZone, date) => {
    let toReturn = '';
    const d = new Date(date);
    const adjustedDate = d.toLocaleString('en-US', { timeZone, hour12: false, timeZoneName: 'short' });
    let [day, timeWithZone] = adjustedDate.split(',');
    timeWithZone = timeWithZone.split(' ');
    let time = timeWithZone[1];
    const zone = timeWithZone[2];
    day = day.split('/');
    time = time.split(':');
    toReturn += `${day[0]}/${day[1]} ${time[0]}:${time[1]} ${zone}`;
    return toReturn;
  },
};

export default D3Utility;
